import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import { Menu, MenuItem } from "@material-ui/core";
import { FormControl, InputLabel } from "@material-ui/core";
import Select from "react-select"
import { Checkbox, FormControlLabel, Grid } from "@material-ui/core";
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"

import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import TableSortLabel from "@material-ui/core/TableSortLabel"


import "react-modern-calendar-datepicker/lib/DatePicker.css"
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import Calendar from "react-modern-calendar-datepicker";

import LinearProgress from "@material-ui/core/LinearProgress"

import RequestSmsReceiver from "./RequestSmsReceiver";
import FloatingLabelInput from "./FloatingLabelInput";
import FilterPanel from "./FilterPanel";
import Grow from "@material-ui/core/Grow";
import CustomSelect from "./common/CustomSelect";
import Box from "@material-ui/core/Box";
import MarketerBaseState from "./MarketerBase/MarketerBaseState";
import MarketerBaseService from "./MarketerBase/MarketerBaseService"; // مسیر بسته به پروژه‌ات تنظیم کن

const styles = (theme) => ({

    customDatePickerWrapper: {
        display: "block !important",
        width: "100% !important",
        position: "relative",
        zIndex: 100,
    },


    paperrtl: {
        marginTop: theme.spacing(0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    paper: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },
    root: {
        width: "100%",
        margin: "15px",
        padding: "8px",
        direction: "rtl",
    },
    container: {
        maxHeight: 400,
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
    progress: {
        width: '100%',
        height: 10, // ارتفاع نوار درصد
    },
    progressContainer: {
        width: '100px', // عرض نوار درصد
    },
    errorBorder: {
        '& .react-select__control': {
            border: '1px solid red !important',
            borderRadius: 4,
        },
    },


})
const Text = (props) => {
    return (
        <Container>
            <div className="main-textt">
                <div className="text-title">{props.title}</div>
                <div className="text-detail">{props.detail}</div>
            </div>
        </Container>
    );
};

class RenewalIssuanceMarketerRequests extends Component {
    cookies = new Cookies()
    temp333
    constructor(props) {
        super(props)
        this.state = { ...MarketerBaseState };

    }
    handleTherapyInsurer = (selectedTherapyInsurer) => {
        this.setState({ selectedTherapyInsurer: selectedTherapyInsurer })
    }
    handleChangethirdpartyInsurancePrice = (event) => {
        this.setState({ thirdpartyInsurancePrice: event })
    }
    handlethirdpartyAddress = (event) => {
        this.setState({ thirdpartyAddress: event.target.value });
    }
    handlebodycarAddress = (event) => {
        this.setState({ bodycarAddress: event.target.value });
    }
    handleChangebodyCarInsurancePrice = (event) => {
        this.setState({ bodyCarInsurancePrice: event })
    }

    setSelectedDayStart = (event) => {
        this.setState({ selectedDayStart: event }, () => {
            // this.filterList();
        });
    };

    setselectedDateCallback = (event) => {
        this.setState({ selectedDateCallback: event });
    };
    setselectedThirdpartyDateOfSubmission = (event) => {
        this.setState({ selectedThirdpartyDateOfSubmission: event });
    };
    setthirdPartyInsuranceStartDate = (event) => {
        this.setState({ thirdPartyInsuranceStartDate: event });
    };
    setbodyCarInsuranceStartDate = (event) => {
        this.setState({ bodyCarInsuranceStartDate: event });
    };
    setthirdPartyEndDateOfInsurance = (event) => {
        this.setState({ thirdPartyEndDateOfInsurance: event });
    };
    setbodyCarEndDateOfInsurance = (event) => {
        this.setState({ bodyCarEndDateOfInsurance: event });
    };
    setselectedBodycarDateOfSubmission = (event) => {
        this.setState({ selectedBodycarDateOfSubmission: event });
    };
    setSelectedDayEnd = (event) => {
        this.setState({ selectedDayEnd: event }, () => {
            // this.filterList();
        });
    };
    handleChangeDesc = (event) => {
        this.setState({ call_back_desc: event.target.value });
    };
    handleThirdpartyPostalCode = (event) => {
        this.setState({ thirdparty_postal_code: event.target.value });
    };
    handleThirdpartyPolicyNumber = (event) => {
        this.setState({ thirdparty_policy_number: event.target.value });
    };
    handleBodycarPostalCode = (event) => {
        this.setState({ bodycar_postal_code: event.target.value });
    };

    handleCheckboxChange = (event) => {
        // تغییر وضعیت چک‌باکس
        this.setState({ isChecked: event.target.checked ? "true" : "false" });
    };
    gotoDetailRequest = (id,call_back_desc,call_back_status,call_back_date,selectedThirdpartyDateOfSubmission,
                         selectedBodycarDateOfSubmission,selectedBodycarDateOfVisit,thirdPartyInsuranceStartDate,thirdPartyEndDateOfInsurance,bodyCarEndDateOfInsurance,bodyCarInsuranceStartDate) => {

        this.setState({ call_back_desc: call_back_desc })
        this.setState({ isChecked: call_back_status })
        if (call_back_date) {
            const [year, month, day] = call_back_date.split('/').map(Number);
            const parsedDate = { year, month, day };
            this.setState({ selectedDateCallback: parsedDate });
        } else {
            this.setState({ selectedDateCallback: null });
        }


        if (selectedThirdpartyDateOfSubmission) {


            const [year, month, day] = selectedThirdpartyDateOfSubmission.split('/').map(Number);
            const parsedDate = { year, month, day };
            this.setState({ selectedThirdpartyDateOfSubmission: parsedDate });
        } else {
            this.setState({ selectedThirdpartyDateOfSubmission: null });
        }
        if (thirdPartyInsuranceStartDate) {


            const [year, month, day] = thirdPartyInsuranceStartDate.split('/').map(Number);
            const parsedDate = { year, month, day };
            this.setState({ thirdPartyInsuranceStartDate: parsedDate });
        } else {
            this.setState({ thirdPartyInsuranceStartDate: null });
        }
        if (bodyCarInsuranceStartDate) {


            const [year, month, day] = bodyCarInsuranceStartDate.split('/').map(Number);
            const parsedDate = { year, month, day };
            this.setState({ bodyCarInsuranceStartDate: parsedDate });
        } else {
            this.setState({ bodyCarInsuranceStartDate: null });
        }
        if (thirdPartyEndDateOfInsurance) {


            const [year, month, day] = thirdPartyEndDateOfInsurance.split('/').map(Number);
            const parsedDate = { year, month, day };
            this.setState({ thirdPartyEndDateOfInsurance: parsedDate });
        } else {
            this.setState({ thirdPartyEndDateOfInsurance: null });
        }
        if (bodyCarEndDateOfInsurance) {


            const [year, month, day] = bodyCarEndDateOfInsurance.split('/').map(Number);
            const parsedDate = { year, month, day };
            this.setState({ bodyCarEndDateOfInsurance: parsedDate });
        } else {
            this.setState({ bodyCarEndDateOfInsurance: null });
        }
        if (selectedBodycarDateOfSubmission) {


            const [year, month, day] = selectedBodycarDateOfSubmission.split('/').map(Number);
            const parsedDate = { year, month, day };
            this.setState({ selectedBodycarDateOfSubmission: parsedDate });
        } else {
            this.setState({ selectedBodycarDateOfSubmission: null });
        }
        if (selectedBodycarDateOfVisit) {


            const [year, month, day] = selectedBodycarDateOfVisit.split('/').map(Number);
            const parsedDate = { year, month, day };
            this.setState({ selectedBodycarDateOfVisit: parsedDate });
        } else {
            this.setState({ selectedBodycarDateOfVisit: null });
        }


        if (this.state.request_id === id) {
            this.setState({ request_id: null });
        }else {
            this.setState({ request_id: id })

        }
        this.setState({
            insuranceType: '',
            selectedCompany: null,
            thirdpartyInsurancePrice: '',
            ThirdpartyPaymentType: null,
            ThirdpartyPostingType: null,
            // selectedThirdpartyDateOfSubmission: null,
            thirdparty_postal_code: '',
            thirdpartyAddress: '',
            thirdpartyShippingAddress: '',

            bodyCarInsurancePrice: '',
            BodycarPaymentType: null,
            BodycarPostingType: null,
            BodycarVisitType: null,
            // selectedBodycarDateOfSubmission: null,
            bodycar_postal_code: '',
            bodycarAddress: '',
            bodycarShippingAddress: ''

        });



    }

    handleChangeCheakbox = (request_id) => {
        const { selectedDayEnd } = this.state;
        const { selectedDayStart } = this.state;
        const { call_back_desc } = this.state;
        const { isChecked } = this.state;
        const { selectedDateCallback } = this.state;

        const formatDate = ({ day, month, year }) => {
            const paddedMonth = month.toString().padStart(2, '0');
            const paddedDay = day.toString().padStart(2, '0');
            return `${year}/${paddedMonth}/${paddedDay}`;
        };

        const formattedDateCallback = formatDate(selectedDateCallback);


        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if (arr.result === "ok") {

                    if (selectedDayStart && selectedDayEnd ) {
                        self.datafilter(); // دریافت و به‌روزرسانی داده‌ها


                    }else {
                        self.getSmsReceiver(); // دریافت و به‌روزرسانی داده‌ها

                    }




                } else if (arr.result === "error") {
                    // در صورت خطا، هیچ عملی انجام نمی‌دهیم
                }

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });

                // پس از به‌روزرسانی داده‌ها، مرتب‌سازی دوباره اعمال می‌شود
                // self.applySorting(); // فراخوانی تابع برای اعمال مرتب‌سازی دوباره
            }
        };

        var fd = new FormData();
        fd.append("command", "change_cheakbox");
        fd.append("id", request_id);
        fd.append("cheak_box_desc", call_back_desc);
        fd.append("isChecked", isChecked);
        fd.append("formattedDateCallback", formattedDateCallback);

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    };

    handleChangeCheakbox2 = (request_id,val) => {
        var self = this;
        const { selectedDayEnd } = this.state;
        const { selectedDayStart } = this.state;

        const {
            selectedCompany,
            thirdparty_policy_number,
            thirdPartyInsuranceStartDate,
            bodyCarInsuranceStartDate,
            thirdPartyEndDateOfInsurance,
            bodyCarEndDateOfInsurance,
        } = this.state;

        console.log('thirdparty_policy_number',thirdparty_policy_number)


        const formatDate = ({ day, month, year }) => {
            const paddedMonth = month.toString().padStart(2, '0');
            const paddedDay = day.toString().padStart(2, '0');
            return `${year}/${paddedMonth}/${paddedDay}`;
        };
        console.log('val',val)

        if (val === 'thirdparty') {
            if (
                !thirdPartyInsuranceStartDate ||
                !thirdPartyEndDateOfInsurance
            ) {
                self.setState({ snackstr: "لطفاً تمام فیلدهای بیمه ثالث را کامل کنید.", showSnack: true, snackMode: "error" })

                return;
            }
        }

        else if (val === 'bodily') {
            if (
                !bodyCarInsuranceStartDate ||
                !bodyCarEndDateOfInsurance
            ) {
                self.setState({ snackstr: "لطفاً تمام فیلدهای بیمه بدنه را کامل کنید.", showSnack: true, snackMode: "error" })
                return;
            }
        }



        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if (arr.result === "ok") {

                    if (selectedDayStart && selectedDayEnd ) {
                        self.datafilter(); // دریافت و به‌روزرسانی داده‌ها


                    }else {
                        self.getSmsReceiver(); // دریافت و به‌روزرسانی داده‌ها

                    }
                } else if (arr.result === "error") {

                    self.setState({ snackstr: arr.message, showSnack: true, snackMode: "error" })

                }

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });
            }
        };

        var fd = new FormData();
        fd.append("command", "add_issuance_time");
        fd.append("insuranceType", val);
        fd.append("id", request_id);


        if (val === 'thirdparty') {
            const start = formatDate(thirdPartyInsuranceStartDate);
            const end = formatDate(thirdPartyEndDateOfInsurance);

            fd.append("company", selectedCompany ? selectedCompany.value : "");
            fd.append("thirdparty_policy_number", thirdparty_policy_number);
            fd.append("thirdPartyInsuranceStartDate", start);
            fd.append("thirdPartyEndDateOfInsurance", end);

        }

        else if (val === 'bodily') {
            const start = formatDate(bodyCarInsuranceStartDate);
            const end = formatDate(bodyCarEndDateOfInsurance);

            fd.append("company", selectedCompany ? selectedCompany.value : "");
            fd.append("bodyCarInsuranceStartDate", start);
            fd.append("bodyCarEndDateOfInsurance", end);

        }



        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);



    };



    handleClick = (event, rowId) => {
        this.setState({
            anchorEl: event.currentTarget,
            selectedRowId: rowId,
        });
    };

    handleClose = () => {
        this.setState({
            anchorEl: null,
            selectedRowId: null,
        });
    };


    handleCallStatusUpdate2 = (smsStatus) => {
        const { currentRowId ,selectedDayStart , selectedDayEnd} = this.state;


        this.handleClose(); // بستن منو

        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if (arr.result === "ok") {
                    if (selectedDayStart && selectedDayEnd ) {
                        self.datafilter(); // دریافت و به‌روزرسانی داده‌ها


                    }else {
                        self.getSmsReceiver(); // دریافت و به‌روزرسانی داده‌ها

                    }

                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    if (selectedDayStart && selectedDayEnd ) {
                        self.datafilter(); // دریافت و به‌روزرسانی داده‌ها


                    }else {
                        self.getSmsReceiver(); // دریافت و به‌روزرسانی داده‌ها

                    }

                    // در صورت خطا، هیچ عملی انجام نمی‌دهیم
                }

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });

                // پس از به‌روزرسانی داده‌ها، مرتب‌سازی دوباره اعمال می‌شود
                // self.applySorting(); // فراخوانی تابع برای اعمال مرتب‌سازی دوباره
            }
        };

        var fd = new FormData();
        fd.append("command", "change_is_called_issuance");
        fd.append("id", currentRowId);
        fd.append("call_status_id", smsStatus);

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    };


    handleResendSms = (id) => {
        const { currentRowId } = this.state;


        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if (arr.result === "ok") {
                    self.getSmsReceiver(); // دریافت و به‌روزرسانی داده‌ها
                } else if (arr.result === "error") {
                    // در صورت خطا، هیچ عملی انجام نمی‌دهیم
                }

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });

                // پس از به‌روزرسانی داده‌ها، مرتب‌سازی دوباره اعمال می‌شود
                // self.applySorting(); // فراخوانی تابع برای اعمال مرتب‌سازی دوباره
            }
        };

        var fd = new FormData();
        fd.append("command", "resend_sms");
        fd.append("excel_name", "naft");
        fd.append("id", id);

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    };





    handleSelectRows = (row2) => {
        this.setState(
            {
                id: row2.id,
                accident_main_coverage_name: row2.accident_main_coverage_name,
                insurer: row2.insurer,
                full_name: row2.full_name,
                issued_by: row2.issued_by,
                typePolicy: row2.typePolicy,
                beginDate: row2.beginDate,
                endDate: row2.endDate,
                sms_date: row2.sms_date,
                excel_name: row2.excel_name,
                vehicalName: row2.vehicalName,
                plateNumber: row2.plateNumber,
                policyholder: row2.policyholder,
                relation: row2.relation,
                parent_name: row2.parent_name,
                phone_number: row2.phone_number,
                personnel_no: row2.personnel_no,
                management_name: row2.management_name,
                company_name: row2.company_name,
                nationalCode: row2.nationalCode,
                message_content: row2.message_content,
                resend_sms: row2.resend_sms,
                discountFinance: row2.discountFinance,
                discountLife: row2.discountLife,
                discountDriver: row2.discountDriver,
                lastPolicyNumber: row2.lastPolicyNumber,
                policyNumber: row2.policyNumber,
                policyUniqueCode: row2.policyUniqueCode,
                engineNumber: row2.engineNumber,
                chassisNo: row2.chassisNo,
                vin: row2.vin,
                call_back_desc: row2.call_back_desc,
                call_back_date: row2.call_back_date,
                call_back_status: row2.call_back_status,
                employee_id: row2.employee_id,
                auth_id: row2.auth_id,
                is_called: row2.is_called,
                last_status: row2.last_status,
                request_id: row2.request_id,
                thirdpartyInsurancePrice: row2.insurancePrice,
                newAccidentMainCoverage: false,
            },
            () => {}
        )
    }




    toggleEmployeeFilter = () => {
        this.setState(prevState => ({
            isEmployeeFilterActive: !prevState.isEmployeeFilterActive
        }));
    };
    newAccidentMainCoverage = (event) => {
        this.setState({
            id: "",
            accident_main_coverage_name: "",
            insurer: "",
            newAccidentMainCoverage: true,
        })
    }
    componentDidMount() {
        if (!this.cookies.get("employee_token_str")) {
            this.setState({ redirect: true });
            return;
        }

        this.props.props.props.dispatch({ type: "WAITSHOW" });

        const self = this;

        const fd = new FormData();
        fd.append("command", "checkemployeelogin");

        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                const arr = JSON.parse(this.responseText);
                if (arr.result === "ok") {
                    Promise.all([
                        MarketerBaseService.getPostingType(),
                        MarketerBaseService.getPeymentType(),
                        MarketerBaseService.getVisitType(),
                        MarketerBaseService.getCompany()
                    ])
                        .then(([PostingType, PeymentType, VisitType, Company]) => {
                            self.setState({
                                optionPostingType: PostingType,
                                optionPeymentType: PeymentType,
                                optionVisitType: VisitType,
                                optionCompany: Company
                            });
                        })
                        .catch(err => self.setState({ snackstr: err, showSnack: true, snackMode: "error" }));

                    self.getSmsReceiverStatus();
                    self.getSmsReceiver();

                } else if (arr.result === "error") {
                    self.setState({ redirect: true });
                }

                self.props.props.props.dispatch({ type: "WITEHIDE" });
            }
        };

        xhttp.open("POST", `${constants.BASE_URL}/employeelogin`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    }


    getSmsReceiver = () => {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });
        this.setState({
            selectedDayEnd: "",
            selectedDayStart: "",
            selectedStatus: "",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();

        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);

                if (arr.result === "ok") {
                    // ذخیره داده‌ها در state
                    self.setState(
                        {
                            requestinfos: arr.data,
                            agentInfofilter: arr.data
                        },
                        () => {
                            // بعد از ذخیره داده‌ها، مرتب‌سازی را اعمال می‌کنیم
                            self.applySorting(); // مرتب‌سازی داده‌ها
                        }
                    );
                } else if (arr.result === "error") {
                    // در صورت بروز خطا هیچ عملی انجام نمی‌دهیم
                }

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });
            }
        };

        var fd = new FormData();
        fd.append("command", "get_renewal_issuance_requests");

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    }


    handleCallStatusUpdate3 = (id) => {


        console.log("hey u ",id)
        window.open(`https://user.rahnamayefarda.ir/thirdparty2?id=${id}`, "_blank");

        // window.open(`http://localhost:3000/thirdparty2?id=${id}`, "_blank");



        // اینجا کد بروزرسانی وضعیت را اضافه کنید
    };


    getSmsReceiverStatus() {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ requestinfos: arr.data, agentInfofilter2: arr.data }, () => {})
                } else if (arr.result === "error") {
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "get_issuance_status")

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }



    // تابع برای اعمال مرتب‌سازی دوباره بر اساس فیلد و وضعیت مرتب‌سازی
    applySorting = () => {
        const { orderBy2, order2 } = this.state;
        const arrayTemp = [...this.state.agentInfofilter];

        // مرتب‌سازی بر اساس فیلدهای مختلف
        arrayTemp.sort((a, b) => {
            let comparisonResult = 0;

            // مقایسه داده‌ها در ترتیب اولویت
            for (let i = 0; i < orderBy2.length; i++) {
                const field = orderBy2[i];
                const orderDirection = order2[i];

                const valueA = field === 'endDate' ? new Date(a[field]) : a[field];
                const valueB = field === 'endDate' ? new Date(b[field]) : b[field];

                if (orderDirection === 'asc') {
                    comparisonResult = valueA < valueB ? -1 : (valueA > valueB ? 1 : 0);
                } else {
                    comparisonResult = valueA > valueB ? -1 : (valueA < valueB ? 1 : 0);
                }

                if (comparisonResult !== 0) break; // اگر مقایسه‌ها نتیجه‌دار شدند، دیگر مقایسه نمی‌کنیم
            }

            return comparisonResult;
        });

        // به‌روزرسانی state با داده‌های مرتب‌شده
        this.setState({ agentInfofilter: arrayTemp });
    };




    createSortHandler = (field) => {
        const { orderBy2, order2 } = this.state;

        const fieldIndex = orderBy2.indexOf(field);

        // اگر فیلد جدید است، آن را به لیست اضافه می‌کنیم
        if (fieldIndex === -1) {
            this.setState(
                {
                    orderBy2: [...orderBy2, field],
                    order2: [...order2, 'asc'], // پیش‌فرض ترتیب صعودی است
                },
                this.applySorting
            );
        } else {
            // اگر فیلد قبلاً وجود دارد، ترتیب آن را تغییر می‌دهیم
            const newOrder = [...order2];
            newOrder[fieldIndex] = newOrder[fieldIndex] === 'asc' ? 'desc' : 'asc';

            this.setState(
                {
                    order2: newOrder
                },
                this.applySorting
            );
        }
    };


    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
    }

    handleChangePage = (event, number) => {
        this.setState({ page: parseInt(number, 0) })
    }
    filterRows = () => {

        const { agentInfofilter, isEmployeeFilterActive, searchText } = this.state;

        return agentInfofilter
            .filter((row) => {
                if (isEmployeeFilterActive && row.employee_id !== row.auth_id) return false;

                if (!searchText.trim()) return true;

                const lowerSearch = searchText.toLowerCase();

                // چک کن ببین آیا حداقل یکی از فیلدها شامل سرچ هست
                return Object.values(row).some((value) =>
                    String(value).toLowerCase().includes(lowerSearch)
                );
            });
    };

    datafilter = () => {


        const { selectedDayStart, selectedDayEnd, searchText, selectedStatus } = this.state;

        if (selectedDayStart && selectedDayEnd ) {
            // همه دارای مقدار هستن
            const formatDate = ({ day, month, year }) => {
                const paddedMonth = month.toString().padStart(2, '0');
                const paddedDay = day.toString().padStart(2, '0');
                return `${year}/${paddedMonth}/${paddedDay}`;
            };

            const formattedStartDate = formatDate(selectedDayStart);
            const formattedEndDate = formatDate(selectedDayEnd);
            const selectedStatusId = selectedStatus;

            // Dispatch action to show waiting state
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            });

            // استفاده از XMLHttpRequest برای ارسال داده‌ها
            var xhttp = new XMLHttpRequest();

            xhttp.onreadystatechange = () => {  // استفاده از تابع پیکانی
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    var arr = JSON.parse(xhttp.responseText);

                    if (arr.result === "ok") {
                        // ذخیره داده‌ها در state
                        this.setState(
                            {
                                requestinfos: arr.data,
                                agentInfofilter: arr.data
                            },
                            () => {
                                // بعد از ذخیره داده‌ها، مرتب‌سازی را اعمال می‌کنیم
                                this.applySorting(); // مرتب‌سازی داده‌ها
                            }
                        );
                    } else if (arr.result === "error") {
                        // در صورت بروز خطا هیچ عملی انجام نمی‌دهیم
                    }

                    // Dispatch action to hide waiting state
                    this.props.props.props.dispatch({
                        type: "WITEHIDE",
                    });
                }
            };

            var fd = new FormData();
            fd.append("command", "get_renewal_issuance_requests");
            fd.append("StartDate", formattedStartDate);
            fd.append("EndDate", formattedEndDate);
            fd.append("StatusId", selectedStatusId);

            xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
            xhttp.send(fd);
        }else {

            this.setState({ snackstr: "لطفا تاریخ شروع و پایان را وارد کنید", showSnack: true, snackMode: "error" })

        }


    };
    handleCompanyChange = (selectedCompany) => {
        this.setState({ selectedCompany });
    };

    handleThirdpartyPaymentType = (ThirdpartyPaymentType) => {
        console.log('asli',ThirdpartyPaymentType)
        this.setState({ ThirdpartyPaymentType });
    };
    handleBodycarPaymentType = (BodycarPaymentType) => {
        this.setState({ BodycarPaymentType });
    };

    handleThirdpartyPostingType = (ThirdpartyPostingType) => {
        this.setState({ ThirdpartyPostingType });
    };
    handleBodycarPostingType = (BodycarPostingType) => {
        this.setState({ BodycarPostingType });
    };




    render() {
        const { anchorEl } = this.state; // موقعیت منو
        const { orderBy2, order2 } = this.state;
        const { classes } = this.props
        const {
            BodycarPaymentType,
            ThirdpartyPaymentType,
            ThirdpartyPostingType,
            BodycarPostingType,
            BodycarVisitType,
            selectedCompany,
            optionCompany,
            optionPostingType,
            optionVisitType,
            optionPeymentType,
            thirdpartyInsurancePrice,
            thirdpartyAddress,
            thirdpartyShippingAddress,
            thirdpartySameAddress,
            bodycarAddress,
            bodycarShippingAddress,
            bodyCarInsurancePrice,
            optionTherapyInsurer,
            selectedTherapyInsurer,
            agentPermision,
            snackMode,
            snackstr,
            showSnack,
            isEmployeeFilterActive,
            newAccidentMainCoverage,
            id,
            accident_main_coverage_name,
            searchText,
            insurer,
            full_name,
            issued_by,
            typePolicy,
            beginDate,
            endDate,
            vehicalName,
            plateNumber,
            policyholder,
            phone_number,
            nationalCode,
            message_content,
            call_back_desc,
            thirdparty_policy_number,
            bodycar_policy_number,
            thirdparty_postal_code,
            bodycar_postal_code,
            call_back_date,
            selectedDayEnd,
            selectedDayStart,
            selectedDateCallback,
            thirdPartyInsuranceStartDate,
            bodyCarInsuranceStartDate,
            thirdPartyEndDateOfInsurance,
            bodyCarEndDateOfInsurance,
            selectedThirdpartyDateOfSubmission,
            selectedBodycarDateOfSubmission,
            call_back_status,
            discountFinance,
            discountLife,
            discountDriver,
            lastPolicyNumber,
            policyNumber,
            policyUniqueCode,
            engineNumber,
            is_called,
            order,
            orderBy,
            okstatus,
            errstr,
            redirect,
            agentInfofilter,
            agentInfofilter2,
            rowsPerPage,
            page,
            cheak_box_desc,

        } = this.state


        if (redirect) {
            return <Redirect to="/" />
        } else {
            return (
                <div className={classes.paperrtl} dir="ltr">
                    <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        onClose={this.handleClickcloseTasckBar}
                        open={showSnack}
                        autoHideDuration={10000}
                    >
                        <Alert severity={snackMode}>{snackstr}</Alert>
                    </Snackbar>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Container maxWidth="xl">

                                <FilterPanel
                                    className={classes.root}
                                    searchText={this.state.searchText}
                                    onSearchTextChange={(val) => this.setState({ searchText: val })}
                                    selectedDayStart={this.state.selectedDayStart}
                                    onStartDateChange={(val) => this.setState({ selectedDayStart: val })}
                                    selectedDayEnd={this.state.selectedDayEnd}
                                    onEndDateChange={(val) => this.setState({ selectedDayEnd: val })}
                                    selectedStatus={this.state.selectedStatus}
                                    onStatusChange={(val) => this.setState({ selectedStatus: val })}
                                    statusOptions={agentInfofilter2.map(item => ({
                                        value: item.sms_status_id,
                                        label: item.sms_status
                                    }))}
                                    onSearch={this.datafilter}
                                    onBase={this.getSmsReceiver}
                                    excel='Marketer'

                                />

                                <Paper className={classes.root}>
                                    <TableContainer dir="rtl">
                                        <Table aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    {/*<TableCell*/}
                                                    {/*    key={"id"}*/}
                                                    {/*    align={"center"}*/}
                                                    {/*    style={{ minWidth: 20 }}*/}
                                                    {/*    sortDirection={orderBy === "id" ? order : false}*/}
                                                    {/*>*/}
                                                    {/*    {"آیدی "}*/}
                                                    {/*    <TableSortLabel*/}
                                                    {/*        active={orderBy === "id"}*/}
                                                    {/*        direction={*/}
                                                    {/*            orderBy === "id" ? order : "asc"*/}
                                                    {/*        }*/}
                                                    {/*        onClick={(e) => {*/}
                                                    {/*            this.createSortHandler("id")*/}
                                                    {/*        }}*/}
                                                    {/*    ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}

                                                    <TableCell
                                                        key={"insurer"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شرکت بیمه"}
                                                        <TableSortLabel
                                                            active={orderBy === "insurer"}
                                                            direction={
                                                                orderBy === "insurer" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("insurer")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    {/*<TableCell*/}
                                                    {/* key={"typePolicy"}*/}
                                                    {/* align={"center"}*/}
                                                    {/* style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/* {"typePolicy"}*/}
                                                    {/* <TableSortLabel*/}
                                                    {/* active={orderBy === "typePolicy"}*/}
                                                    {/* direction={*/}
                                                    {/* orderBy === "typePolicy" ? order : "asc"*/}
                                                    {/* }*/}
                                                    {/* onClick={(e) => {*/}
                                                    {/* this.createSortHandler("typePolicy")*/}
                                                    {/* }}*/}
                                                    {/* ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}
                                                    {/*<TableCell*/}
                                                    {/* key={"beginDate"}*/}
                                                    {/* align={"center"}*/}
                                                    {/* style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/* {"beginDate"}*/}
                                                    {/* <TableSortLabel*/}
                                                    {/* active={orderBy === "beginDate"}*/}
                                                    {/* direction={*/}
                                                    {/* orderBy === "beginDate" ? order : "asc"*/}
                                                    {/* }*/}
                                                    {/* onClick={(e) => {*/}
                                                    {/* this.createSortHandler("beginDate")*/}
                                                    {/* }}*/}
                                                    {/* ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}
                                                    <TableCell
                                                        key={"endDate"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تاریخ پایان"}
                                                        <TableSortLabel
                                                            active={orderBy2.includes("endDate")}
                                                            direction={orderBy2.includes("endDate") ? order2[orderBy2.indexOf("endDate")] : "asc"}
                                                            onClick={() => this.createSortHandler("endDate")}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        key={"sms_date"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تاریخ ارجاع"}
                                                        <TableSortLabel
                                                            active={orderBy2.includes("sms_date")}
                                                            direction={orderBy2.includes("sms_date") ? order2[orderBy2.indexOf("sms_date")] : "asc"}
                                                            onClick={() => this.createSortHandler("sms_date")}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        key={"excel_name"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نام اکسل"}
                                                        <TableSortLabel
                                                            active={orderBy2.includes("excel_name")}
                                                            direction={orderBy2.includes("excel_name") ? order2[orderBy2.indexOf("excel_name")] : "asc"}
                                                            onClick={() => this.createSortHandler("excel_name")}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        key={"plateNumber"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"پلاک ماشین"}
                                                        <TableSortLabel
                                                            active={orderBy === "plateNumber"}
                                                            direction={
                                                                orderBy === "plateNumber" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("plateNumber")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"policyholder"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نام/نام خانوادگی"}
                                                        <TableSortLabel
                                                            active={orderBy === "policyholder"}
                                                            direction={
                                                                orderBy === "policyholder" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("policyholder")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"phone_number"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شماره موبایل"}
                                                        <TableSortLabel
                                                            active={orderBy === "phone_number"}
                                                            direction={
                                                                orderBy === "phone_number" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("phone_number")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    {/*<TableCell*/}
                                                    {/* key={"nationalCode"}*/}
                                                    {/* align={"center"}*/}
                                                    {/* style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/* {"nationalCode"}*/}
                                                    {/* <TableSortLabel*/}
                                                    {/* active={orderBy === "nationalCode"}*/}
                                                    {/* direction={*/}
                                                    {/* orderBy === "nationalCode" ? order : "asc"*/}
                                                    {/* }*/}
                                                    {/* onClick={(e) => {*/}
                                                    {/* this.createSortHandler("nationalCode")*/}
                                                    {/* }}*/}
                                                    {/* ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}
                                                    <TableCell
                                                        key={"message_content"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"متن پیامک"}
                                                        <TableSortLabel
                                                            active={orderBy === "message_content"}
                                                            direction={
                                                                orderBy === "message_content" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("message_content")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    {/*<TableCell*/}
                                                    {/*    key={"resend_sms"}*/}
                                                    {/*    align={"center"}*/}
                                                    {/*    style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/*    {"پیامک مجدد"}*/}
                                                    {/*    <TableSortLabel*/}
                                                    {/*        active={orderBy === "resend_sms"}*/}
                                                    {/*        direction={*/}
                                                    {/*            orderBy === "resend_sms" ? order : "asc"*/}
                                                    {/*        }*/}
                                                    {/*        onClick={(e) => {*/}
                                                    {/*            this.createSortHandler("resend_sms")*/}
                                                    {/*        }}*/}
                                                    {/*    ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}
                                                    <TableCell
                                                        key={"call_back_desc"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تماس مجدد"}
                                                        <br />
                                                        <TableSortLabel
                                                            active={orderBy2.includes("call_back_status")}
                                                            direction={orderBy2.includes("call_back_status") ? order2[orderBy2.indexOf("call_back_status")] : "asc"}
                                                            onClick={() => this.createSortHandler("call_back_status")}
                                                        />
                                                    </TableCell>




                                                    {/*<TableCell*/}
                                                    {/*    key={"is_called"}*/}
                                                    {/*    align={"center"}*/}
                                                    {/*    style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/*    {"تعیین وضعیت"}*/}
                                                    {/*    <br/>*/}
                                                    {/*    <TableSortLabel*/}
                                                    {/*        active={orderBy === "is_called"}*/}
                                                    {/*        direction={*/}
                                                    {/*            orderBy === "is_called" ? order : "asc"*/}
                                                    {/*        }*/}
                                                    {/*        onClick={(e) => {*/}
                                                    {/*            this.createSortHandler("is_called")*/}
                                                    {/*        }}*/}
                                                    {/*    ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}
                                                    <TableCell
                                                        key={"last_status"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"آخرین وضعیت"}
                                                        <br />
                                                        <TableSortLabel
                                                            active={orderBy2.includes("last_status")}
                                                            direction={orderBy2.includes("last_status") ? order2[orderBy2.indexOf("last_status")] : "asc"}
                                                            onClick={() => this.createSortHandler("last_status")}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        key={"last_status"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"کارمند صدور"}
                                                        <br />
                                                        <TableSortLabel
                                                            active={orderBy2.includes("last_status")}
                                                            direction={orderBy2.includes("last_status") ? order2[orderBy2.indexOf("last_status")] : "asc"}
                                                            onClick={() => this.createSortHandler("last_status")}
                                                        />
                                                    </TableCell>

                                                    {/*<TableCell*/}
                                                    {/*    key={"price"}*/}
                                                    {/*    align={"center"}*/}
                                                    {/*    style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/*    {"قیمت"}*/}
                                                    {/*    <br/>*/}
                                                    {/*    <TableSortLabel*/}
                                                    {/*        active={orderBy === "price"}*/}
                                                    {/*        direction={*/}
                                                    {/*            orderBy === "price" ? order : "asc"*/}
                                                    {/*        }*/}
                                                    {/*        onClick={(e) => {*/}
                                                    {/*            this.createSortHandler("price")*/}
                                                    {/*        }}*/}
                                                    {/*    ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}

                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {/*<div>*/}
                                                {/*    /!* دکمه برای فعال/غیرفعال کردن شرط *!/*/}
                                                {/*    <Button*/}
                                                {/*        variant="contained"*/}
                                                {/*        color="primary"*/}
                                                {/*        onClick={this.toggleEmployeeFilter}*/}
                                                {/*    >*/}
                                                {/*        {isEmployeeFilterActive ? 'غیرفعال کردن فیلتر' : 'فعال کردن فیلتر'}*/}
                                                {/*    </Button>*/}
                                                {/*</div>*/}


                                                {this.filterRows()
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((row) => {
                                                        if (isEmployeeFilterActive && row.employee_id !== row.auth_id) {
                                                            return null;
                                                        }
                                                        const color = row.percentage < 50 ? 'red' : row.percentage < 80 ? 'yellow' : 'green';
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row["id"]}
                                                                value={row}
                                                                onClick={() => {
                                                                    this.
                                                                    gotoDetailRequest(row.id,row.call_back_desc,row.call_back_status,row.call_back_date,
                                                                        row.selectedThirdpartyDateOfSubmission,row.selectedBodycarDateOfSubmission,row.selectedBodycarDateOfVisit,
                                                                        row.thirdPartyInsuranceStartDate,row.thirdPartyEndDateOfInsurance,row.bodyCarEndDateOfInsurance,
                                                                        row.bodyCarInsuranceStartDate)
                                                                }}
                                                                style={{
                                                                    backgroundColor:
                                                                        row.last_status === "در حال بررسی"
                                                                            ? "#F5F5DC" // زرد کرمی
                                                                            : row.last_status === "تمدید شد"
                                                                                ? "#EAF3FB" // سبز ملایم
                                                                                : row.last_status === "بررسی نشده"
                                                                                    ? "#FDEDEC" // قرمز ملایم
                                                                                    : row.last_status === "نهایی شد"
                                                                                        ? "#E6F4EA" // سبز نعناعی ملایم
                                                                                        : "transparent",

                                                                    transition: "background-color 0.3s ease",
                                                                }}
                                                            >
                                                                {/*<TableCell*/}
                                                                {/*    key={"id"}*/}
                                                                {/*    align={"center"}*/}
                                                                {/*>*/}
                                                                {/*    {row["id"]}*/}
                                                                {/*</TableCell>*/}

                                                                <TableCell
                                                                    key={"insurer"}
                                                                    align={"center"}
                                                                >
                                                                    {row["insurer"]}
                                                                </TableCell>
                                                                {/*<TableCell*/}
                                                                {/* key={"typePolicy"}*/}
                                                                {/* align={"center"}*/}
                                                                {/*>*/}
                                                                {/* {row["typePolicy"]}*/}
                                                                {/*</TableCell>*/}
                                                                {/*<TableCell*/}
                                                                {/* key={"beginDate"}*/}
                                                                {/* align={"center"}*/}
                                                                {/*>*/}
                                                                {/* {row["beginDate"]}*/}
                                                                {/*</TableCell>*/}
                                                                <TableCell
                                                                    key={"endDate"}
                                                                    align={"center"}
                                                                >
                                                                    {row["endDate"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"sms_date"}
                                                                    align={"center"}
                                                                >
                                                                    {row["sms_date"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"excel_name"}
                                                                    align={"center"}
                                                                >
                                                                    {row["excel_name"]}
                                                                </TableCell>
                                                                {/*<TableCell*/}
                                                                {/* key={"vehicalName"}*/}
                                                                {/* align={"center"}*/}
                                                                {/*>*/}
                                                                {/* {row["vehicalName"]}*/}
                                                                {/*</TableCell>*/}
                                                                <TableCell
                                                                    key={"plateNumber"}
                                                                    align={"center"}
                                                                >
                                                                    {row["plateNumber"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"policyholder"}
                                                                    align={"center"}
                                                                >
                                                                    {row["policyholder"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"phone_number"}
                                                                    align={"center"}
                                                                >
                                                                    {row["phone_number"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"message_content"}
                                                                    align={"center"}
                                                                >
                                                                    {row["message_content"]}
                                                                </TableCell>
                                                                {/*<TableCell*/}
                                                                {/*    key={"resend_sms"}*/}
                                                                {/*    align={"center"}*/}
                                                                {/*>*/}
                                                                {/*    {row["resend_sms"]}*/}
                                                                {/*    <div>*/}
                                                                {/*        /!* دکمه برای فعال/غیرفعال کردن شرط *!/*/}
                                                                {/*        <Button*/}
                                                                {/*            variant="contained"*/}
                                                                {/*            color="primary"*/}
                                                                {/*            disabled={row["resend_sms"] == 1 || row["excel_name"] == 'مشتری های قدیمی' }*/}

                                                                {/*            onClick={(event) => {*/}
                                                                {/*                event.stopPropagation(); // جلوگیری از انتشار رویداد کلیک*/}
                                                                {/*                this.handleResendSms(row.id);*/}
                                                                {/*            }}*/}

                                                                {/*        >*/}

                                                                {/*            پیامک مجدد*/}
                                                                {/*        </Button>*/}
                                                                {/*    </div>*/}


                                                                {/*</TableCell>*/}
                                                                <TableCell
                                                                    key={"call_back_desc"}
                                                                    align={"center"}
                                                                    style={{
                                                                        backgroundColor: row["call_back_status"] === "true" ? "green" : "transparent", // سبز در حالت true
                                                                        color: row["call_back_status"] === "true" ? "white" : "inherit", // متن سفید فقط در حالت true
                                                                    }}
                                                                >
                                                                    {/*{row["call_back_status"] === "true" ? "بله" : "خیر"}*/}
                                                                    <br />
                                                                    {row["call_back_date"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"last_status"}
                                                                    align={"center"}
                                                                >
                                                                    {row["last_status"]}
                                                                    {<h5> ({row["full_name"]}) </h5>}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"last_status"}
                                                                    align={"center"}
                                                                >
                                                                    {<h5>({row["issued_by"]})</h5>}
                                                                </TableCell>

                                                            </TableRow>
                                                        )
                                                    })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 100]}
                                        component="div"
                                        count={this.filterRows().length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </Paper>
                            </Container>

                            <Container component="main" maxWidth="lg">

                                <Container maxWidth="lg">
                                    {agentInfofilter
                                        .map((row) => {
                                            const color = this.state['request_id'];

                                            const selectedPaymentOption =
                                                optionPeymentType.find(option => option.value === (this.state.thirdpartyPaymentType || row.thirdpartyPaymentType)) || null;

                                            const selectedPostingOption =
                                                optionPostingType.find(option => option.value === (this.state.thirdpartyPostingType || row.thirdpartyPostingType)) || null;

                                            const selectedthirdpartyCompany =
                                                optionCompany.find(option => option.value === (this.state.selectedCompany || row.thirdpartyCompany)) || null;

                                            const selectedbodycarCompany =
                                                optionCompany.find(option => option.value === (this.state.selectedCompany || row.bodycarCompany)) || null;

                                            const selectedBodycarPaymentOption =
                                                optionPeymentType.find(option => option.value === (this.state.BodycarPaymentType || row.BodycarPaymentType)) || null;

                                            const selectedBodycarPostingOption =
                                                optionPostingType.find(option => option.value === (this.state.BodycarPostingType || row.BodycarPostingType)) || null;
                                            const selectedBodycarVisitOption =
                                                optionVisitType.find(option => option.value === (this.state.BodycarVisitType || row.BodycarVisitType)) || null;


                                            if (color === row.id) {
                                                return (
                                                    <TableContainer component={Paper}>
                                                        <Table aria-label="vertical table">
                                                            <TableBody style={{ textAlign: "center" , direction: "rtl",}}>
                                                                <TableRow>
                                                                    <TableCell align="center">بیمه‌گر</TableCell> {/* insurer */}
                                                                    <TableCell align="center">{row.insurer}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نوع بیمه‌نامه</TableCell> {/* typePolicy */}
                                                                    <TableCell align="center">{row.typePolicy}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">تاریخ شروع</TableCell> {/* beginDate */}
                                                                    <TableCell align="center">{row.beginDate}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نام خودرو</TableCell> {/* vehicalName */}
                                                                    <TableCell align="center">{row.vehicalName}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره پلاک</TableCell> {/* plateNumber */}
                                                                    <TableCell align="center">{row.plateNumber}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نسبت با سرپرست</TableCell> {/* policyholder */}
                                                                    <TableCell align="center">{row.relation}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نام سرپرست (در صورت وجود)</TableCell> {/* policyholder */}
                                                                    <TableCell align="center">{row.parent_name}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">بیمه‌گذار</TableCell> {/* policyholder */}
                                                                    <TableCell align="center">{row.policyholder}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره موبایل</TableCell> {/* phone_number */}
                                                                    <TableCell align="center">{row.phone_number}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره پرسنلی</TableCell> {/* personnel_no */}
                                                                    <TableCell align="center">{row.personnel_no}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نام مدیریت</TableCell> {/* management_name */}
                                                                    <TableCell align="center">{row.management_name}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نام شرکت</TableCell> {/* company_name */}
                                                                    <TableCell align="center">{row.company_name}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">کد ملی</TableCell> {/* nationalCode */}
                                                                    <TableCell align="center">{row.nationalCode}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">تخفیف مالی</TableCell> {/* discountFinance */}
                                                                    <TableCell style={{ textAlign: "-webkit-center" }}>
                                                                        <div className={classes.progressContainer}>
                                                                            <LinearProgress
                                                                                className={classes.progress}
                                                                                variant="determinate"
                                                                                value={
                                                                                    row["discountFinance"].match(/\((-?\d+)%\)/)
                                                                                        ? Math.max(0, parseFloat(row["discountFinance"].match(/\((-?\d+)%\)/)[1]))
                                                                                        : 0
                                                                                } />
                                                                        </div>
                                                                        {row["discountFinance"]}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">تخفیف جانی</TableCell> {/* discountLife */}
                                                                    <TableCell style={{ textAlign: "-webkit-center" }}>
                                                                        <div className={classes.progressContainer}>
                                                                            <LinearProgress
                                                                                className={classes.progress}
                                                                                variant="determinate"
                                                                                value={
                                                                                    row["discountLife"].match(/\((-?\d+)%\)/)
                                                                                        ? Math.max(0, parseFloat(row["discountLife"].match(/\((-?\d+)%\)/)[1]))
                                                                                        : 0
                                                                                }
                                                                            />
                                                                        </div>
                                                                        {row["discountLife"]}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">تخفیف راننده</TableCell> {/* discountDriver */}
                                                                    <TableCell style={{ textAlign: "-webkit-center", direction: "rtl" }}>
                                                                        <div className={classes.progressContainer}>
                                                                            <LinearProgress
                                                                                className={classes.progress}
                                                                                variant="determinate"
                                                                                value={
                                                                                    row["discountDriver"].match(/\((-?\d+)%\)/)
                                                                                        ? Math.max(0, parseFloat(row["discountDriver"].match(/\((-?\d+)%\)/)[1]))
                                                                                        : 0
                                                                                }
                                                                            />
                                                                        </div>
                                                                        {row["discountDriver"]}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره بیمه‌نامه قبلی</TableCell> {/* lastPolicyNumber */}
                                                                    <TableCell align="center">{row.lastPolicyNumber}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره بیمه‌نامه</TableCell> {/* policyNumber */}
                                                                    <TableCell align="center">{row.policyNumber}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">کد یکتای بیمه‌نامه</TableCell> {/* policyUniqueCode */}
                                                                    <TableCell align="center">{row.policyUniqueCode}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره موتور</TableCell> {/* engineNumber */}
                                                                    <TableCell align="center">{row.engineNumber}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره شاسی</TableCell> {/* chassisNo */}
                                                                    <TableCell align="center">{row.chassisNo}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">کد VIN</TableCell> {/* vin */}
                                                                    <TableCell align="center">{row.vin}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">توضیح تماس بعدی</TableCell> {/* Call back */}
                                                                    <TableCell align="center">{row.call_back_desc}</TableCell>
                                                                </TableRow>

                                                            </TableBody>
                                                        </Table>



                                                        <Container maxWidth="lg">
                                                            <Paper style={{ minHeight: '200px' }} className={classes.root}>


                                                                <Box
                                                                    sx={{
                                                                        backgroundColor: '#e3f2fd', // آبی روشن
                                                                        // padding: '16px',
                                                                        borderRadius: '8px',
                                                                        textAlign: 'center',
                                                                        marginBottom: '24px',
                                                                        border: '1px solid #90caf9', // آبی کم‌رنگ
                                                                    }}
                                                                >
                                                                    <Typography
                                                                        variant="h6"
                                                                        style={{
                                                                            fontWeight: 'bold',
                                                                            color: '#1976d2', // آبی اصلی
                                                                            fontSize: "14px",      // اینجا سایز فونت رو تنظیم کردیم
                                                                        }}
                                                                    >
                                                                        بیمه ثالث
                                                                    </Typography>
                                                                </Box>

                                                                {row.thirdpartyCompany && (
                                                                    <>

                                                                        <Grid container spacing={2}>
                                                                            <Grid item xs={12} sm={4} style={{ marginTop: '15px' }}>
                                                                                <div style={{ border: !selectedCompany && !selectedthirdpartyCompany  ? "1px solid red" : "none", borderRadius: 4 }}>

                                                                                    <CustomSelect
                                                                                        isSearchable
                                                                                        className="adapter-txtsize"
                                                                                        placeholder="شرکت بیمه"
                                                                                        // value={selectedCompany}
                                                                                        value={selectedCompany || selectedthirdpartyCompany || ""}

                                                                                        onChange={this.handleCompanyChange}
                                                                                        options={optionCompany}
                                                                                        isDisabled={row.thirdpartyCompany}  // اگر مقدار تو row بود، غیرقابل تغییر

                                                                                    />
                                                                                </div>
                                                                            </Grid>

                                                                            <Grid item xs={12} sm={4}>
                                                                                <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="مبلغ بیمه"
                                                                                    value={ row.thirdpartyInsurancePrice || ""}
                                                                                    disabled={row.thirdpartyInsurancePrice}
                                                                                />
                                                                            </Grid>

                                                                            <Grid item xs={12} sm={4} style={{ marginTop: '15px' }}>

                                                                                <div style={{ border: !ThirdpartyPaymentType && !selectedPaymentOption ? "1px solid red" : "none", borderRadius: 4 }}>


                                                                                    {console.log('row',row)}
                                                                                    <CustomSelect
                                                                                        isSearchable
                                                                                        className="adapter-txtsize"
                                                                                        placeholder="نحوه پرداخت"
                                                                                        value={ThirdpartyPaymentType || selectedPaymentOption || ""}
                                                                                        options={optionPeymentType}
                                                                                        isDisabled={row.thirdpartyPaymentType}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                                    />
                                                                                </div>
                                                                            </Grid>

                                                                            {/* ردیف دوم */}
                                                                            <Grid item xs={12} sm={4}>
                                                                                <div style={{ border: !ThirdpartyPostingType && !selectedPostingOption ? "1px solid red" : "none", borderRadius: 4 }}>

                                                                                    <CustomSelect
                                                                                        isSearchable
                                                                                        className="adapter-txtsize"
                                                                                        placeholder="نحوه ارسال"
                                                                                        value={ThirdpartyPostingType || selectedPostingOption || ""}

                                                                                        options={optionPostingType}
                                                                                        isDisabled={row.thirdpartyPostingType}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                                    />
                                                                                </div>
                                                                            </Grid>

                                                                            <Grid item xs={12} sm={4}>
                                                                                <Calendar
                                                                                    containerClassName="datepicker-fix"
                                                                                    renderInput={({ ref }) => (
                                                                                        <TextField
                                                                                            fullWidth
                                                                                            inputRef={ref}
                                                                                            variant="outlined"
                                                                                            value={
                                                                                                this.state.selectedThirdpartyDateOfSubmission
                                                                                                    ? `${this.state.selectedThirdpartyDateOfSubmission.year}/${String(this.state.selectedThirdpartyDateOfSubmission.month).padStart(2, "0")}/${String(this.state.selectedThirdpartyDateOfSubmission.day).padStart(2, "0")}`
                                                                                                    : ""
                                                                                            }
                                                                                            placeholder="تاریخ ارسال"
                                                                                            disabled
                                                                                        />
                                                                                    )}
                                                                                    value={this.state.selectedThirdpartyDateOfSubmission}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                                    disabled={row.selectedThirdpartyDateOfSubmission}  // اگر مقدار تو row بود، غیرقابل تغییر

                                                                                />
                                                                            </Grid>

                                                                            <Grid item xs={12} sm={4} style={{ marginTop: '-15px' }}>
                                                                                <FloatingLabelInput
                                                                                    placeholder="کد پستی"
                                                                                    handleInputt={this.handleThirdpartyPostalCode}
                                                                                    value={row.thirdparty_postal_code || ""}
                                                                                    disabled={row.thirdparty_postal_code}
                                                                                />
                                                                            </Grid>

                                                                            {/* ردیف سوم */}

                                                                            <Grid item xs={12}>
                                                                                <TextField
                                                                                    className="adapter-txtsize"
                                                                                    placeholder="آدرس دقیق"
                                                                                    fullWidth
                                                                                    multiline
                                                                                    rows={3}
                                                                                    value={row.thirdpartyAddress || ""}
                                                                                    disabled={row.thirdpartyAddress}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={3}>
                                                                                آدرس ارسال همان آدرس بیمه نامه هم هست؟
                                                                                <FormControlLabel
                                                                                    control={
                                                                                        <Checkbox
                                                                                            checked={row.thirdpartySameAddress === "true"} // چک با رشته
                                                                                            color="primary"
                                                                                        />
                                                                                    }
                                                                                    label={row.thirdpartySameAddress === "true" ? "بله" : "خیر"}
                                                                                />
                                                                            </Grid>

                                                                            {row.thirdpartySameAddress === "false" && (
                                                                                <Grid item xs={9}>
                                                                                    <TextField
                                                                                        className="adapter-txtsize"
                                                                                        placeholder="آدرس دقیق ارسال"
                                                                                        fullWidth
                                                                                        multiline
                                                                                        rows={3}
                                                                                        value={
                                                                                            thirdpartyShippingAddress || row.thirdpartyShippingAddress || ""
                                                                                        }
                                                                                        disabled={row.thirdpartyShippingAddress} // اگه تو row بود، غیرقابل تغییر
                                                                                    />
                                                                                </Grid>
                                                                            )}




                                                                        </Grid>
                                                                        <Box
                                                                            sx={{
                                                                                backgroundColor: '#c8e6c9', // سبز خیلی روشن (پس‌زمینه)
                                                                                // padding: '16px',
                                                                                borderRadius: '8px',
                                                                                textAlign: 'center',
                                                                                marginBottom: '24px',
                                                                                border: '1px solid #81c784', // سبز ملایم‌تر (حاشیه)
                                                                            }}
                                                                        >
                                                                            <Typography
                                                                                variant="h6"
                                                                                style={{
                                                                                    fontWeight: 'bold',
                                                                                    color: '#388e3c', // سبز تیره‌تر (متن)
                                                                                    fontSize: "14px",      // اینجا سایز فونت رو تنظیم کردیم

                                                                                }}
                                                                            >
                                                                                صدور بیمه ثالث
                                                                            </Typography>
                                                                        </Box>

                                                                        <Grid container spacing={2}>


                                                                            <Grid item xs={12} sm={4}>
                                                                                <Calendar
                                                                                    containerClassName="datepicker-fix"
                                                                                    renderInput={({ ref }) => (
                                                                                        <TextField
                                                                                            fullWidth
                                                                                            inputRef={ref}
                                                                                            variant="outlined"
                                                                                            value={
                                                                                                this.state.thirdPartyInsuranceStartDate
                                                                                                    ? `${this.state.thirdPartyInsuranceStartDate.year}/${String(this.state.thirdPartyInsuranceStartDate.month).padStart(2, "0")}/${String(this.state.thirdPartyInsuranceStartDate.day).padStart(2, "0")}`
                                                                                                    : ""
                                                                                            }
                                                                                            placeholder="تاریخ شروع"
                                                                                            disabled
                                                                                        />
                                                                                    )}
                                                                                    value={this.state.thirdPartyInsuranceStartDate}
                                                                                    onChange={(val) => this.setthirdPartyInsuranceStartDate(val)}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends


                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={4}>
                                                                                <Calendar
                                                                                    containerClassName="datepicker-fix"
                                                                                    renderInput={({ ref }) => (
                                                                                        <TextField
                                                                                            fullWidth
                                                                                            inputRef={ref}
                                                                                            variant="outlined"
                                                                                            value={
                                                                                                this.state.thirdPartyEndDateOfInsurance
                                                                                                    ? `${this.state.thirdPartyEndDateOfInsurance.year}/${String(this.state.thirdPartyEndDateOfInsurance.month).padStart(2, "0")}/${String(this.state.thirdPartyEndDateOfInsurance.day).padStart(2, "0")}`
                                                                                                    : ""
                                                                                            }
                                                                                            placeholder="تاریخ پایان"
                                                                                            disabled
                                                                                        />
                                                                                    )}
                                                                                    value={this.state.thirdPartyEndDateOfInsurance}
                                                                                    onChange={(val) => this.setthirdPartyEndDateOfInsurance(val)}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends


                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={4} style={{ marginTop: '-15px' }}>
                                                                                <FloatingLabelInput
                                                                                    placeholder="شماره بیمه نامه"
                                                                                    handleInputt={this.handleThirdpartyPolicyNumber}
                                                                                    value={thirdparty_policy_number || row.thirdparty_policy_number || ""}
                                                                                    error={(thirdparty_policy_number || row.thirdparty_policy_number || "") === ""}
                                                                                    helperText={(thirdparty_policy_number || row.thirdparty_policy_number || "") === "" ? "شماره بیمه نامه  الزامی است" : ""}
                                                                                    disabled
                                                                                    // disabled={row.thirdparty_policy_number}
                                                                                />
                                                                            </Grid>

                                                                        </Grid>


                                                                    </>

                                                                )}


                                                                <Box
                                                                    sx={{
                                                                        backgroundColor: '#e3f2fd', // آبی روشن
                                                                        // padding: '16px',
                                                                        borderRadius: '8px',
                                                                        textAlign: 'center',
                                                                        marginBottom: '24px',
                                                                        marginTop: '24px',
                                                                        border: '1px solid #90caf9', // آبی کم‌رنگ
                                                                    }}
                                                                >
                                                                    <Typography
                                                                        variant="h6"
                                                                        style={{
                                                                            fontWeight: 'bold',
                                                                            color: '#1976d2', // آبی اصلی
                                                                            fontSize: "14px",      // اینجا سایز فونت رو تنظیم کردیم

                                                                        }}
                                                                    >
                                                                        بیمه بدنه
                                                                    </Typography>
                                                                </Box>
                                                                {row.bodycarCompany && (

                                                                    <>

                                                                        <Grid container spacing={2}>
                                                                            <Grid item xs={12} sm={4} style={{ marginTop: '15px' }}>
                                                                                <div style={{ border: !selectedCompany && !selectedbodycarCompany  ? "1px solid red" : "none", borderRadius: 4 }}>
                                                                                    <CustomSelect
                                                                                        isSearchable
                                                                                        className="adapter-txtsize"
                                                                                        placeholder="شرکت بیمه"
                                                                                        onChange={this.handleCompanyChange}
                                                                                        value={selectedCompany || selectedbodycarCompany || ""}

                                                                                        options={optionCompany}
                                                                                        isDisabled={row.bodycarCompany}
                                                                                    />
                                                                                </div>
                                                                            </Grid>

                                                                            <Grid item xs={12} sm={4}>
                                                                                <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="مبلغ بیمه"
                                                                                    handleInputt={this.handleChangebodyCarInsurancePrice}

                                                                                    value={bodyCarInsurancePrice || row.bodyCarInsurancePrice || ""}
                                                                                    error={(bodyCarInsurancePrice || row.bodyCarInsurancePrice || "") === ""}
                                                                                    helperText={(bodyCarInsurancePrice || row.bodyCarInsurancePrice || "") === "" ? "مبلغ بیمه الزامی است" : ""}
                                                                                    disabled={row.bodyCarInsurancePrice}
                                                                                />
                                                                            </Grid>

                                                                            <Grid item xs={12} sm={4} style={{ marginTop: '15px' }}>
                                                                                <div style={{ border: !BodycarPaymentType && !selectedBodycarPaymentOption ? "1px solid red" : "none", borderRadius: 4 }}>
                                                                                    <CustomSelect
                                                                                        isSearchable
                                                                                        className="adapter-txtsize"
                                                                                        placeholder="نحوه پرداخت"
                                                                                        onChange={this.handleBodycarPaymentType}
                                                                                        selectedBodycarPaymentOption

                                                                                        value={BodycarPaymentType || selectedBodycarPaymentOption || ""}
                                                                                        options={optionPeymentType}
                                                                                        isDisabled={row.BodycarPaymentType}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                                    />
                                                                                </div>
                                                                            </Grid>

                                                                            <Grid item xs={12} sm={4}>
                                                                                <div style={{ border: !BodycarPostingType && !selectedBodycarPostingOption ? "1px solid red" : "none", borderRadius: 4 }}>
                                                                                    <CustomSelect
                                                                                        isSearchable
                                                                                        className="adapter-txtsize"
                                                                                        placeholder="نحوه ارسال"
                                                                                        onChange={this.handleBodycarPostingType}
                                                                                        options={optionPostingType}

                                                                                        value={BodycarPostingType || selectedBodycarPostingOption || ""}

                                                                                        isDisabled={row.BodycarPostingType}
                                                                                    />
                                                                                </div>
                                                                            </Grid>



                                                                            <Grid item xs={12} sm={4}>
                                                                                <Calendar
                                                                                    containerClassName="datepicker-fix"
                                                                                    renderInput={({ ref }) => (
                                                                                        <TextField
                                                                                            fullWidth
                                                                                            inputRef={ref}
                                                                                            variant="outlined"
                                                                                            value={
                                                                                                this.state.selectedBodycarDateOfSubmission
                                                                                                    ? `${this.state.selectedBodycarDateOfSubmission.year}/${String(this.state.selectedBodycarDateOfSubmission.month).padStart(2, "0")}/${String(this.state.selectedBodycarDateOfSubmission.day).padStart(2, "0")}`
                                                                                                    : ""
                                                                                            }
                                                                                            placeholder="تاریخ ارسال"
                                                                                            // error={!this.state.selectedBodycarDateOfSubmission}
                                                                                            // helperText={!this.state.selectedBodycarDateOfSubmission ? "تاریخ الزامی است" : ""}
                                                                                            disabled
                                                                                        />
                                                                                    )}
                                                                                    value={this.state.selectedBodycarDateOfSubmission}
                                                                                    onChange={(val) => this.setselectedBodycarDateOfSubmission(val)}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                                    disabled={row.selectedBodycarDateOfSubmission}  // اگر مقدار تو row بود، غیرقابل تغییر

                                                                                />
                                                                            </Grid>

                                                                            <Grid item xs={12} sm={4} style={{ marginTop: '-15px' }}>
                                                                                <FloatingLabelInput
                                                                                    placeholder="کد پستی"
                                                                                    handleInputt={this.handleBodycarPostalCode}

                                                                                    value={bodycar_postal_code || row.bodycar_postal_code || ""}
                                                                                    error={(bodycar_postal_code || row.bodycar_postal_code || "") === ""}
                                                                                    helperText={(bodycar_postal_code || row.bodycar_postal_code || "") === "" ? "مبلغ بیمه الزامی است" : ""}
                                                                                    disabled={row.bodycar_postal_code}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={4}>
                                                                                <div style={{ border: !BodycarVisitType && !selectedBodycarVisitOption ? "1px solid red" : "none", borderRadius: 4 }}>
                                                                                    <CustomSelect
                                                                                        isSearchable
                                                                                        className="adapter-txtsize"
                                                                                        placeholder="نوع بازدید"
                                                                                        options={optionVisitType}

                                                                                        value={BodycarVisitType || selectedBodycarVisitOption || ""}

                                                                                        isDisabled={row.BodycarVisitType}
                                                                                    />
                                                                                </div>
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={4}>
                                                                                <Calendar
                                                                                    containerClassName="datepicker-fix"
                                                                                    renderInput={({ ref }) => (
                                                                                        <TextField
                                                                                            fullWidth
                                                                                            inputRef={ref}
                                                                                            variant="outlined"
                                                                                            value={
                                                                                                this.state.selectedBodycarDateOfVisit
                                                                                                    ? `${this.state.selectedBodycarDateOfVisit.year}/${String(this.state.selectedBodycarDateOfVisit.month).padStart(2, "0")}/${String(this.state.selectedBodycarDateOfVisit.day).padStart(2, "0")}`
                                                                                                    : ""
                                                                                            }
                                                                                            placeholder="تاریخ بازدید"
                                                                                            disabled
                                                                                        />
                                                                                    )}
                                                                                    value={this.state.selectedBodycarDateOfVisit}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                                    disabled={row.selectedBodycarDateOfVisit}  // اگر مقدار تو row بود، غیرقابل تغییر

                                                                                />
                                                                            </Grid>

                                                                            <Grid item xs={12}>
                                                                                <TextField
                                                                                    className="adapter-txtsize"
                                                                                    placeholder="آدرس دقیق"
                                                                                    fullWidth
                                                                                    multiline
                                                                                    rows={3}
                                                                                    value={bodycarAddress || row.bodycarAddress || ""}

                                                                                    onChange={this.handlebodycarAddress}
                                                                                    error={ (bodycarAddress === "" && (!row.bodycarAddress || row.bodycarAddress === "")) }
                                                                                    helperText={ (bodycarAddress === "" && (!row.bodycarAddress || row.bodycarAddress === "")) ? "آدرس الزامی است" : "" }

                                                                                    disabled={row.bodycarAddress}

                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={3}>
                                                                                آدرس ارسال همان آدرس بیمه نامه هم هست؟
                                                                                <FormControlLabel
                                                                                    control={
                                                                                        <Checkbox
                                                                                            checked={row.bodycarSameAddress === "true"} // چک با رشته
                                                                                            color="primary"
                                                                                        />
                                                                                    }
                                                                                    label={row.bodycarSameAddress === "true" ? "بله" : "خیر"}
                                                                                />
                                                                            </Grid>

                                                                            {row.bodycarSameAddress ==="false" && (
                                                                                <Grid item xs={9}>
                                                                                    <TextField
                                                                                        className="adapter-txtsize"
                                                                                        placeholder="آدرس دقیق ارسال"
                                                                                        fullWidth
                                                                                        multiline
                                                                                        rows={3}
                                                                                        value={
                                                                                            bodycarShippingAddress || row.bodycarShippingAddress || ""
                                                                                        }
                                                                                        disabled={row.bodycarShippingAddress}

                                                                                    />
                                                                                </Grid>
                                                                            )}

                                                                        </Grid>

                                                                        <Box
                                                                            sx={{
                                                                                backgroundColor: '#c8e6c9', // سبز خیلی روشن (پس‌زمینه)
                                                                                // padding: '16px',
                                                                                borderRadius: '8px',
                                                                                textAlign: 'center',
                                                                                marginBottom: '24px',
                                                                                border: '1px solid #81c784', // سبز ملایم‌تر (حاشیه)
                                                                            }}
                                                                        >
                                                                            <Typography
                                                                                variant="h6"
                                                                                style={{
                                                                                    fontWeight: 'bold',
                                                                                    color: '#388e3c', // سبز تیره‌تر (متن)
                                                                                    fontSize: "14px",      // اینجا سایز فونت رو تنظیم کردیم

                                                                                }}
                                                                            >
                                                                                صدور بیمه بدنه
                                                                            </Typography>
                                                                        </Box>


                                                                        <Grid container spacing={2}>


                                                                            <Grid item xs={12} sm={4}>
                                                                                <Calendar
                                                                                    containerClassName="datepicker-fix"
                                                                                    renderInput={({ ref }) => (
                                                                                        <TextField
                                                                                            fullWidth
                                                                                            inputRef={ref}
                                                                                            variant="outlined"
                                                                                            value={
                                                                                                this.state.bodyCarInsuranceStartDate
                                                                                                    ? `${this.state.bodyCarInsuranceStartDate.year}/${String(this.state.bodyCarInsuranceStartDate.month).padStart(2, "0")}/${String(this.state.bodyCarInsuranceStartDate.day).padStart(2, "0")}`
                                                                                                    : ""
                                                                                            }
                                                                                            placeholder="تاریخ شروع"
                                                                                            disabled
                                                                                        />
                                                                                    )}
                                                                                    value={this.state.bodyCarInsuranceStartDate}
                                                                                    onChange={(val) => this.setbodyCarInsuranceStartDate(val)}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends

                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={4}>
                                                                                <Calendar
                                                                                    containerClassName="datepicker-fix"
                                                                                    renderInput={({ ref }) => (
                                                                                        <TextField
                                                                                            fullWidth
                                                                                            inputRef={ref}
                                                                                            variant="outlined"
                                                                                            value={
                                                                                                this.state.bodyCarEndDateOfInsurance
                                                                                                    ? `${this.state.bodyCarEndDateOfInsurance.year}/${String(this.state.bodyCarEndDateOfInsurance.month).padStart(2, "0")}/${String(this.state.bodyCarEndDateOfInsurance.day).padStart(2, "0")}`
                                                                                                    : ""
                                                                                            }
                                                                                            placeholder="تاریخ پایان"
                                                                                            disabled
                                                                                        />
                                                                                    )}
                                                                                    value={this.state.bodyCarEndDateOfInsurance}
                                                                                    onChange={(val) => this.setbodyCarEndDateOfInsurance(val)}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends


                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={4} style={{ marginTop: '-15px' }}>
                                                                                <FloatingLabelInput
                                                                                    placeholder="شماره بیمه نامه"
                                                                                    handleInputt={this.handleThirdpartyPolicyNumber}
                                                                                    value={bodycar_policy_number || row.bodycar_policy_number || ""}
                                                                                    error={(bodycar_policy_number || row.bodycar_policy_number || "") === ""}
                                                                                    helperText={(bodycar_policy_number || row.bodycar_policy_number || "") === "" ? "شماره بیمه نامه  الزامی است" : ""}
                                                                                    disabled
                                                                                    // disabled={row.thirdparty_policy_number}
                                                                                />
                                                                            </Grid>
                                                                        </Grid>


                                                                    </>
                                                                )}

                                                            </Paper>
                                                        </Container>







                                                    </TableContainer>




                                                )
                                            }

                                        })}




                                </Container>




                                <Container maxWidth="lg">

                                    <RequestSmsReceiver request_id={this.state['request_id']} />
                                </Container>





                            </Container>
                        </Grid>
                    </Grid>


                    {okstatus ? (
                        <Alert severity="success">
                            <AlertTitle>پیام</AlertTitle>
                            {errstr}
                        </Alert>
                    ) : null}
                </div>


            )
        }
    }
}


export default withStyles(styles)(RenewalIssuanceMarketerRequests)
